import { ModulePermission } from 'src/components/ContactForm/types';
import { getTenantName } from 'src/helpers/validationHelper';
import { TabItem } from 'src/pages/Suite/Bottom/types';
import { IContractFile } from '../../../../public/APIContracts/APIContracts';
import { getContractFiles } from 'src/services/client';

// Todo: Resolve root for this hack for GableCraft from API - https://app.asana.com/1/41213529744312/project/1208712340140532/task/1211337293763788?focus=true
const handleGableCraftServiceRequestTab = (
  allowedItemName: string,
  tabLabel: string
) => {
  const tenantName = getTenantName();

  const isGableCraftTenant: boolean =
    tenantName === 'GableCraftMF' || tenantName === 'GableCraft';

  const isValidServiceRequestMapping: boolean =
    allowedItemName === 'Service Requests' &&
    tabLabel === 'Warrantable Requests';

  return isGableCraftTenant && isValidServiceRequestMapping;
};

export const getFilteredTabsForHomeOwner = (
  tabItems: TabItem[],
  allowedTabList: ModulePermission[]
): any[] => {
  if (!allowedTabList?.length) {
    return [];
  }

  const validTabs: TabItem[] = [];

  allowedTabList.forEach((allowedItem: ModulePermission) => {
    const foundTab: TabItem = tabItems.find((tab: TabItem) => {
      const isMatch: boolean =
        tab.label === allowedItem.name ||
        handleGableCraftServiceRequestTab(allowedItem.name, tab.label);

      return isMatch;
    });

    /* TODO: This is a temporary UI-side hack due to a violation of Logical Data Independence.
     * The UI is tightly coupled to the volatile 'Name' column in the database (Conceptual Schema).
     * We are forcing 'Messages' here to reconcile the Data Contract Mismatch where the API
     * returns 'Messages & Announcements'. This should be refactored to use stable Slugs/IDs.
     * See: Raghu Ramakrishnan, DBMS Chapter 1.5.3 / Tech Debt Asana: 1212778316124929 */
    if (foundTab) {
      const finalLabel: string =
        allowedItem.name === 'Messages & Announcements'
          ? 'Messages'
          : foundTab.label;

      validTabs.push({
        ...foundTab,
        label: finalLabel,
      });
    }
  });

  return validTabs;
};

/* TODO: This component violates Logical Data Independence by binding UI logic to volatile DB 'Name' strings.
 * We should eventually refactor the API to return a stable 'slug' or 'key'. See: Raghu Ramakrishnan, DBMS Chapter 1.5.3 */
export const getDynamicMessagesLabel = (allowedTabs: ModulePermission[]) => {
  const messagesModule: ModulePermission = allowedTabs?.find(
    (item: ModulePermission) => item.description === 'Messages'
  );

  return messagesModule?.name || 'Messages';
};

export const fetchContractFiles = async (
  recordSparkContractsCount: any,
  setContractFiles: any,
  suite: any,
  property: any
) => {
  /* legacy/workaround: Units/{id} can report isSpark=true for units under a
   * non-synced project; the project-level flag is the authorization signal
   * (contract files auth with a project-scoped API key). */
  if (!property?.isSpark || !suite?.isSpark || !suite?.id) {
    return;
  }

  try {
    const results: IContractFile[] = await getContractFiles(suite.id);

    recordSparkContractsCount(results.length);
    setContractFiles(results);
  } catch (error) {
    console.error(
      '💥 Unexpected exception encountered while fetching spark contract files:',
      error
    );
  }
};
